import { useContext } from 'react';

import SeedMetadataContext from './SeedMetadataContext';

const useSeedMetadata = () => useContext(SeedMetadataContext);

export default useSeedMetadata;
